@import 'src/styles/palette';

.hierarchyButton {
  display: flex;
  justify-content: center;
  align-items: center;
  border-color: transparent;
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  padding: 0;

  &:hover {
    background-color: _palette(bg-primary-dark);
  }

  &:hover,
  &:focus {
    .icon {
      fill: _palette(secondary);
    }
  }

  .icon {
    margin: auto;
  }
}
